import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import './Banner.css';

const BannerForHome = () => {
  const [banners, setBanners] = useState([]);
  const [page, setPage] = useState([]);
  const { pageSlug } = useParams(); // Extract the blog post titleSlug from the URL

  useEffect(() => {
    fetch(`https://marchtwo202501-5801b8caeb3a.herokuapp.com/page/${pageSlug}`)
      .then((res) => res.json())
      .then((info) => setPage(info))
      .catch((error) => console.error("Error fetching banners:", error));
  }, []);

  // Fetch banners data
  useEffect(() => {
    fetch('https://marchtwo202501-5801b8caeb3a.herokuapp.com/banner')
      .then((res) => res.json())
      .then((info) => setBanners(info))
      .catch((error) => console.error("Error fetching banners:", error));
  }, []);

  // Fetch blog post data when pageSlug changes


  return (


    

    <>

      {
        banners.map(b => b.pageSlug === '' && <section className="hero">
          <div className="hero__wrapper">
            <div className="container">
              <div className="row align-items-lg-center">
                <div className="col-lg-6 order-2 order-lg-1">
                  <h1 className="main-heading color-black">{b.bannerHeading}</h1>
                  <p className="paragraph">
                    {b.bannerDetails}</p>
                  <div className="download-buttons">
                    <a href={b.buttonURL} className="google-play">
                      <i className="fas fa-user" />

                      <div className="button-content">
                        <h6> <span>{b.buttonText}</span></h6>
                      </div>
                    </a>

                  </div>
                </div>
                <div className="col-lg-6 order-1 order-lg-2">
                  <div className="questions-img hero-img">
                    <img src={b.imageOne} alt="image" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>)}
    </>
  );
};

export default BannerForHome;
